import React from 'react';
import styled from 'styled-components/macro';
import { NewModal } from 'lib/components';
import { VerificationStatus } from 'lib/const/VerificationStatus';
import { updateMultipleCustomers } from 'lib/api/superAdminApi';
import { CommonTypography } from 'lib/components/styles/typography';
import { theme } from 'lib/style';
import { SuperAdminCustomerDetails } from 'lib/context';
import { successToast } from 'lib/components/toasts/success';
import { errorToast } from 'lib/components/toasts/error';
import { Button } from 'react-covideo-common';

const SubmitButtonWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: right;
  gap: 10px;
`;

const Title = styled(CommonTypography).attrs({ as: 'p' })`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${theme.palette.covideoGray100};
`;

type Props = {
  newStatus: VerificationStatus;
  customer: SuperAdminCustomerDetails;
  handleModalClose(refresh: boolean): void;
};

export const StatusChangeConfirmationModal = ({
  newStatus,
  customer,
  handleModalClose,
}: Props) => {
  const [loadingModal, setLoadingModal] = React.useState(false);
  const isActive = newStatus === VerificationStatus.ACTIVE;

  const handleUpdateStatus = async () => {
    if (!customer || !customer.customerId) {
      return;
    }

    setLoadingModal(true);
    try {
      await updateMultipleCustomers({
        customerIds: [customer.customerId],
        status: newStatus,
      });
      successToast({ title: 'Customer status updated successfully' });
    } catch (error) {
      errorToast({ title: `Error while updating customer status.` });
      console.log('Error', error);
    }

    handleModalClose(true);
    setLoadingModal(false);
  };

  return (
    <NewModal
      headerText={`${isActive ? 'Activate' : 'Deactivate'} '${
        customer.business
      }'?`}
      hideHeader={false}
      closeModalOnBackdropOrEscPress={true}
      closeModal={() => handleModalClose(false)}
      style={{
        content: {
          minWidth: '592px',
          paddingLeft: '32px',
        },
      }}
    >
      <Title>
        Are you sure you want to {isActive ? 'activate' : 'deactivate'} '
        {customer.business}'?
      </Title>

      <SubmitButtonWrapper>
        <Button
          variant='secondary'
          onClick={() => handleModalClose(false)}
          text={`No, Keep  ${isActive ? 'Inactive' : 'Active'}`}
          disabled={loadingModal}
        />
        <Button
          variant='red'
          onClick={() => handleUpdateStatus()}
          text={`Yes, ${isActive ? 'Activate' : 'Deactivate'}`}
          disabled={loadingModal}
        />
      </SubmitButtonWrapper>
    </NewModal>
  );
};
